import {
    
  GET_FILTERED_PRODUCTS,
    GET_FILTERED_PRODUCTS_SUCCESS,
    GET_PRODUCT_LIST,
    GET_PRODUCT_LIST_SUCCESS,
  } from "../../actions/product/types";
  
  const initialState = {
    
    productsLoading:false,
    products:[],
    count:0,
    
  };
  
  
  
  export const products = (state = initialState, action)=> {
    const { type, payload } = action;
    switch (type) {
  
      case GET_PRODUCT_LIST:
          
        return {
          ...state,
          productsLoading: true,
        };

        case GET_FILTERED_PRODUCTS:
          
          return {
            ...state,
            productsLoading: true,
          };
      case GET_PRODUCT_LIST_SUCCESS:
      
        return {
          ...state,
          productsLoading:false,
          products: payload.results,
          count:payload.count
        };
        case GET_FILTERED_PRODUCTS_SUCCESS:
      
          return {
            ...state,
            productsLoading:false,
            products: payload.results,
            count:payload.count
          };
    
  
     
        default: {
          return state;
        }
    }
  }
  